<template>
  <div id="renderjson"></div>
</template>
<script>
import gitLastCommit from "@/info.json";
import renderjson from "renderjson";

export default {
  mounted() {
    renderjson.set_show_to_level("all");
    document
      .getElementById("renderjson")
      .appendChild(renderjson(gitLastCommit));
  },
};
</script>
